import { TApplicationsProps } from '@marketplace/api';
import {NUMBER_OF_APPS_IN_PAGE} from '../../constants/common'

export const changesRequestParameters = (
  data:TApplicationsProps,
  selectedСategories: string[],
  selectedTypes: string[],
  selectedProducts: string[],
  selectedFacing:string[]
  ) => {

    if(selectedСategories.length> 0) {
      data.categories = selectedСategories.join()
    }
    if(selectedTypes.length> 0) {
      data.types = selectedTypes.join()
    }
    if(selectedProducts.length> 0) {
      data.products = selectedProducts.join()
    }
    if(selectedFacing.length>0) {
      data.facing = selectedFacing.join()
    }

    return data
}

export const calculatesNumberOfApp = (total: number, numberOfApples: number) => {
  if (total - numberOfApples >= NUMBER_OF_APPS_IN_PAGE) {
    return NUMBER_OF_APPS_IN_PAGE
  } else {
    return total - numberOfApples
  }
}